var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.latitude && _vm.longitude)?_c('gmap-map',_vm._b({attrs:{"id":"map"}},'gmap-map',_vm.options,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }